import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "Invoice";

const invoiceStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    getInvoiceList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/getinvlist", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/getsolist", { entNum: param.entNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    copySODetails({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/copyso", {
          SONum: param.SONum,
          entNum: param.entNum,
          loc: param.loc
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getByInvoiceNo({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/get", { txNum: param.txNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getDN({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/getDN", {
          txNum: param.txNum,
          locCode: param.locCode,
          refNum: param.refNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getEventCodeList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/GetEventList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getRefSOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/getrefsolist", {
          entNum: param.entNum,
          itemNum: param.itemNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveInvoice({ commit }, param) {
      console.log(1234);
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/save",
          JSON.stringify({
            header: param.header,
            details: param.details,
            misc: param.misc,
            delivery: param.delivery
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteInvoice({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/delete",
          JSON.stringify({ header: param.header })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getExpiryDateList({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/getexpirydatelistForWeb",
          JSON.stringify({
            itemNum: param.itemNum,
            warehouseLoc: param.warehouseLoc,
            dateTx: param.dateTx
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getMainStockBalance({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/getmainstockbalance",
          JSON.stringify({
            itemNumber: param.itemNum,
            DateExpire: param.expDate
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCustomerDefault({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/common/getcustomerdefault",
          JSON.stringify({ entityNumber: param.entityNum })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCustomerLocationModel({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/common/getcustomerlocationmodel",
          JSON.stringify({
            entNum: param.entityNum,
            entLoc: param.entLoc,
            lang: param.lang
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    calBaseCurAmt({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/calbasecuramt",
          JSON.stringify({
            amtForeign: param.AmountForeign,
            curCode: param.CurCode,
            exRate: param.ExRate
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", param, {
          responseType: "blob"
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    approveInvoice({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/ApproveInvoice", {
          InvoiceNums: param.invNums
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    rejectInvoice({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/RejectInvoice", {
          InvoiceNums: param.invNums
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCustReqAprv({ commit }, param) {
      return new Promise((resolve, reject) => {
        //HTTP.post(baseUrl + '/invoice/CustReqAprv').then(response => {
        HTTP.post(baseUrl + "/invoice/EntitiesNeedApproval")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPickingList({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/GetPickingList", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    updateInvoiceDate({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/ChangeInvoiceDate", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printInvoice({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/printinv20191129",
          { txNum: param.txNum, rptID: param.rptID, updPrtStatus: param.updPrtStatus },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printProformaInvoice({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/printproformainv",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printPickingList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/printpl",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    invRpt({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/invrpt")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSalesAnalysisPivotList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/SalesAnalysisPivotList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printPickingLists({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/printpls",
          { printPickingList: param.printPickingList, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    recalPackagePrice({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/RecalPackagePrice",
          JSON.stringify({
            entityNum: param.entityNum,
            entityLoc: param.entityLoc,
            bundleID: param.bundleID,
            curCode: param.curCode,
            SONum: param.SONum,
            SOLine: param.SOLine,
            dateTx: param.dateTx
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    recalSalesBasket({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/invoice/RecalSalesBasket",
          JSON.stringify({
            entityNum: param.entityNum,
            entityLoc: param.entityLoc,
            curCode: param.curCode,
            dateTx: param.dateTx,
            txDtl: param.txDtl
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default invoiceStore;
